import axios from "fetch-api/fetch-api";
import { IActionResponse } from "../interfaces/base-response";

export function copyApi(uuid: string) {
  return axios.post<IActionResponse>("/copy-shared-cart-v3", { uuid });
}
